// import Swiper JS
import Swiper from 'swiper';

export const promoSlider = () => {

	let promoSliderModules = document.querySelectorAll('.m__pslider');
	if(promoSliderModules){
		
		promoSliderModules.forEach((promoSliderModule) => {

			let promoSliderSlides = promoSliderModule.querySelectorAll('.m__pslider__swiper-slide ');

			let slideVideos 		= promoSliderModule.querySelectorAll('.js__pslider-video');
			//Trigger the first video on page load
			if(slideVideos.length > 0){
				for (var source in slideVideos[0].children) {
				  var videoSource = slideVideos[0].children[source];
				  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				    videoSource.src = videoSource.dataset.src;
				  }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if(promoSliderSlides.length > 1){
				//Initialise the slider
				const pSwiper = new Swiper(promoSliderModule.querySelector('.m__pslider__swiper-wrapper .swiper'), {
					centeredSlides : true,
					slidesPerView : 1,
					rewind : true,
					loop: false,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
				});

				let psliderNavItems 	= promoSliderModule.querySelectorAll('.js__pslider-nav-item');
				let psliderNextArrow 	= promoSliderModule.querySelector('.js__pslider__swiper-next');
				let psliderPrevArrow 	= promoSliderModule.querySelector('.js__pslider__swiper-prev');

				psliderPrevArrow.classList.add('hidden');


			
				


				//Updates when a slide changes
				pSwiper.on('slideChange', function () {


					//Change selected 'nav' item when the slide changes
					psliderNavItems.forEach((navItem) => {
						if(navItem.getAttribute("data-slide-index") == pSwiper.realIndex){
							navItem.classList.add('active');
						}else{
							navItem.classList.remove('active');
						}
					});


					//Stop all videos from playing
					slideVideos.forEach((slideVideo) => {
						slideVideo.pause();
						slideVideo.currentTime = 0;
						slideVideo.load();
					})

					//Check for any videos on the slide and make sure they're lazy-loaded (Had a bug with intersection observer not being triggered due to how swiper loads items)
					let slideVideo = pSwiper.slides[pSwiper.activeIndex].querySelector("video"); 
					if(slideVideo){
						if(!slideVideo.currentTime > 0){ //Only reload video if it isn't already playing
							for (var source in slideVideo.children) {
							  var videoSource = slideVideo.children[source];
							  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							    videoSource.src = videoSource.dataset.src;
							  }
							}
							slideVideo.load();	
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							},1000);
						}
							          
					}

					//Hide next arrow if this is the last slide
					if(pSwiper.isEnd){
						psliderNextArrow.classList.add('hidden');
					}else{
						psliderNextArrow.classList.remove('hidden');
					}

					if(pSwiper.activeIndex == 0){
						psliderPrevArrow.classList.add('hidden');
					}else{
						psliderPrevArrow.classList.remove('hidden');
					}
				});


				//Set up slider nav as swiper if on mobile
				// let pNavSwiper = new Swiper(promoSliderModule.querySelector('.m__pslider__nav-wrapper.swiper'), {
				// 	centeredSlides : false,
				// 	slidesPerView : 'auto',
				// 	keyboard: {
				// 		enabled: true,
				// 		onlyInViewport: true,
				// 	},
				// });


				// pSwiper.controller.control = pNavSwiper;
				// pNavSwiper.controller.control = pSwiper;


				//Update displated slide if 'nav' item clicked
				// psliderNavItems.forEach((navItem) => {
				// 	navItem.addEventListener('click', (event) => {
				// 		pSwiper.slideTo(navItem.getAttribute("data-slide-index"));
				// 	})
				// });

				//Move to next slide if 'prev' arrow clicked
				if(psliderPrevArrow){
					psliderPrevArrow.addEventListener('click', (event) => {
						let prevSlide = pSwiper.activeIndex - 1;
						if(prevSlide < 0){
							prevSlide = pSwiper.slides.length; //Set to the last slide
						}
						pSwiper.slideTo( (prevSlide) );
					})
				}

				//Move to next slide if 'next' arrow clicked
				if(psliderNextArrow){
					psliderNextArrow.addEventListener('click', (event) => {
						let nextSlide = pSwiper.activeIndex + 1;
						if(nextSlide >= pSwiper.slides.length){
							nextSlide = 0; //Return to start!
						}
						pSwiper.slideTo( (nextSlide) );
					})
				}

				//Update displated slide if 'nav' item clicked
				psliderNavItems.forEach((navItem) => {
					navItem.addEventListener('click', (event) => {
						pSwiper.slideTo(navItem.getAttribute("data-slide-index"));
					})
				});
				
			}else{
				//Only 1 slide - don't power up swiper and just manually add the active class (doing a foreach here juuuust in case)
				promoSliderSlides.forEach((slide) => {
					slide.classList.add('swiper-slide-active');
				})
				
			}



		})
		
	}
}
